import type { CourseModule } from "@/core/types";
import { lektionGrundfunktionen } from "./lektion-01-grundfunktionen";
import { lektionBedingt } from "./lektion-02-bedingt";
import { lektionVerweise } from "./lektion-03-verweise";

export const modulFunktionen: CourseModule = {
  id: "funktionen",
  title: "Funktionen, die man wirklich braucht",
  summary:
    "Von SUMME bis SVERWEIS: die Handvoll Funktionen, mit denen sich der weitaus " +
    "größte Teil aller Auswertungen erledigen lässt.",
  level: "Grundlagen",
  lessons: [lektionGrundfunktionen, lektionBedingt, lektionVerweise],
};
